import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BusinessInformation, environment } from '@env';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';

@Component({
  selector: 'app-contact',

  templateUrl: './contact.html',
  imports: [ButtonModule, InputTextModule, TextareaModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactComponent {
  contactInformation: BusinessInformation['contactInfo'] = environment.businessInfo.contactInfo;
}
